<!-- 我的出价 -->
<template>
    <div class="container card" ref="scrollableDiv">
        <el-form :inline="true" :model="formData">
            <!--<el-form-item label="">-->
            <!--<el-select clearable placeholder="选择平台" disabled> </el-select>-->
            <!--</el-form-item>-->
            <el-form-item label="">
                <el-select clearable placeholder="批次号" v-model="formData.patch">
                    <el-option v-for="item in patchList" :key="item" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select clearable placeholder="下单账号" v-model="formData.accountId">
                    <el-option v-for="item in accountIdList" :key="item.id" :label="item.platformName + '/' + item.userAccount" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-input v-model="formData.amountStart" placeholder="最高出价" clearable />
            </el-form-item>
            <el-form-item label="">
                <el-input v-model="formData.amountEnd" placeholder="最低出价" clearable />
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="formData.status" clearable placeholder="是否成功">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-input v-model="formData.stickCode" placeholder="验机码查询" clearable />
            </el-form-item>
            <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                @change="formatDateRange" />
            <br />
            <el-form-item>
                <el-button type="primary" @click="searchOrderHistory()">查询</el-button>
            </el-form-item>
        </el-form>
        <hr />
        <!-- 表格数据 -->
        <div class="form-group">
            <el-container style="margin-top: 0">
                <el-main>
                    <div class="custom-select" style="display: flex; align-items: center; width: 820px">
                        <h3 style="color: white">今日下单:</h3>
                        <div style="margin-left: 20px">
                            <el-switch v-model="istoday" size="large" />
                        </div>
                    </div>

                    <!-- 弹窗 -->
                    <div @keydown.esc="closePopup()">
                        <div class="cartover" id="cartover" @click="closePopup()">
                            <div class="scorllpop" @click.stop>
                                <span class="close-btn" @click="closePopup()" style="color: black; background-color: #babebf">关闭X</span>
                                <detailsCardView ref="detailsCardView" @call-closePopup="closePopup()" :orderAccountList="orderAccountList" />
                            </div>
                        </div>
                    </div>

                    <div class="eltable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 1800px; max-width: 100%; overflow-x: auto; border-radius: 20px"
                            :cell-style="{ height: '50px' }"
                            @row-click="todaybuyclick"
                            :row-style="tableRowStyle"
                            :headerCellStyle="{
                                background: 'rgb(107,107,107)',
                                color: 'white',
                            }"
                            v-loading="loading">
                            <el-table-column header-align="center" align="center" width="80%" label="序号">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" width="80%" label="平台">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.row.sources }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="型号">
                                <template v-slot="scope">
                                    <span v-if="scope">
                                        {{ scope.row.model }}<br />
                                        等级:{{ scope.row.grade }}
                                    </span>
                                    <br />
                                    验机码:<span v-if="scope">{{ scope.row.stickCode }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="颜色">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.row.color }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="存储">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.row.ram }} <span v-if="scope.row.ram">+</span>{{ scope.row.storage }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" v-if="false" align="center" label="验机码">
                                <template v-slot="scope">
                                    <div>
                                        <span v-if="scope">{{ scope.row.stickCode }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="下单信息">
                                <template v-slot="scope">
                                    <span v-if="scope">
                                        {{ scope.row.createdTime }}<br />
                                        批次：{{ scope.row.patch }} <br />
                                        <!-- 起拍价: {{ scope.row.upsetPrice }} <br /> -->
                                        下单账号:<span v-if="scope">{{ scope.row.userAccount }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="起拍价" prop="upsetPrice" header-align="center" align="center" width="120"></el-table-column>
                            <el-table-column header-align="center" align="center" width="120" label="我的出价">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.row.amount }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" width="100" label="当前排名">
                                <template v-slot="scope"> 开发中 </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" width="100" label="当前最高价">
                                <template v-slot="scope"> 开发中 </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" width="100" label="排名时间">
                                <template v-slot="scope"> 开发中 </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="状态">
                                <template v-slot="scope">
                                    <div>
                                        <el-button style="width: 80px" v-if="scope.row.status == 1" type="success">出价成功</el-button>
                                        <el-button style="width: 80px" v-else-if="scope.row.status == 2" type="danger" @click.stop="showfailinfo(scope.row.orderResult)"
                                            >出价失败</el-button
                                        >
                                        <el-button style="width: 80px" v-else-if="scope.row.status == 0" type="primary">出价中</el-button>
                                        <el-button style="width: 80px" v-else-if="scope.row.status == 3" type="warning">跳过审核</el-button>
                                        <el-button style="width: 80px" v-else type="">未知状态</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column header-align="center" align="center" label="操作">
                                <template v-slot="scope">
                                    <el-button color="#626aef" plain @click.stop="">开发中,<br />点其他位置查看</el-button>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column header-align="center" align="center" label="出价结果">
                                <template v-slot="scope">
                                    <div>
                                        {{ scope.row.orderResult }}
                                    </div>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column header-align="center" align="center" label="用户">
                                    <template v-slot="scope">
                                        <span v-if="scope">{{ scope.row.nickName }}</span>
                                    </template>
                                </el-table-column> -->
                            <!-- <el-table-column header-align="center" align="center" label="账号">
                                <template v-slot="scope">
                                    <span v-if="scope">{{ scope.row.userAccount }}</span>
                                </template>
                            </el-table-column> -->
                        </el-table>

                        <el-pagination
                            v-model:currentPage="currentPage"
                            v-model:page-size="itemsPerPage"
                            :page-sizes="[20, 40, 60, 80]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="allpages"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            style="display: flex; justify-content: center; margin-top: 20px" />
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
    <FixedButtons @scroll-to-top="scrollToTop" />
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import detailsCardView from "@/components/detailsCardView.vue";
    import axios from "axios";
    import Swal from "sweetalert2";
    import { mapActions } from "vuex";

    export default {
        name: "mybuyView",
        props: {
            multiplecate: {
                type: Boolean,
                default: false,
            },
        },

        components: { FixedButtons, detailsCardView },
        data() {
            return {
                //时间
                time: "",
                date: "",
                todaypatch: null,

                // 今日出价
                istoday: false,
                data: [],
                filterType: "",
                tableData: [],

                // api接口
                getallOrderURL: "/api/orderDetails/currentOrderList",
                iniselectURL: "/api/orderDetails/init",
                accountURL: "/api/externalAccount/queryExternalAccount",
                orderByURL: "/api/externalAccount/queryOrderExternalAccount",
                warepriceURL: "/api/warePrice/queryWarePrice",

                // 分页数据
                currentPage: 1, // 当前页码
                itemsPerPage: 20, // 每页显示条目数
                maxVisiblePages: 5, // 最多显示的页码数量
                gotoPageNumber: 1, // 用来存储用户输入的页码
                allpages: 1, // 总页数
                datatogo: "", // 要向vuex传递的数据
                allorderList: null,
                testshow: process.env.VUE_APP_SHOW === "true",
                scrollableDiv: null,
                formData: {
                    startTime: "",
                    endTime: "",
                    patch: "", // 批次号
                    accountId: "", // 下单账号
                    amountStart: "", // 最高出价
                    amountEnd: "", // 最低出价
                    stickCode: "", // 验机码
                    status: "", // 状态
                },
                // 下单账号
                orderAccountList: [],
                patchList: [], // 批次号
                accountIdList: [], // 下单账户
                statusList: [], //状态
                dateRange: [null, null],
                input: "",
                loading: true,
            };
        },
        watch: {
            istoday(newValue) {
                if (newValue === true) {
                    this.formData.patch = this.todaypatch;
                } else {
                    this.formData.patch = "";
                }
                this.searchOrderHistory();
            },
            "formData.patch"(newValue) {
                if (typeof newValue === "undefined" || newValue === "" || newValue !== this.todaypatch) {
                    this.istoday = false;
                }
            },
        },
        mounted() {
            // 时间相关
            setInterval(this.updateTime, 1000);
            this.updateTime();

            this.getTableData();
            this.getAllData();
            this.scrollableDiv = this.$refs.scrollableDiv;
        },
        methods: {
            // 显示失败信息
            showfailinfo(infos) {
                Swal.fire({
                    title: "下单失败",
                    icon: "error",
                    text: infos,
                });
            },
            // 页面顶部
            scrollToTop() {
                this.scrollableDiv.scrollTo({
                    top: 0,
                    behavior: "auto",
                });
            },

            // 日期处理
            formatDateRange() {
                // 处理日期范围选择变化事件
                if (this.dateRange[0] && this.dateRange[1]) {
                    this.formData.startTime = this.dateRange[0];
                    this.formData.endTime = this.dateRange[1];
                } else {
                    this.formData.startTime = "";
                    this.formData.endTime = "";
                }
            },

            // 获取下拉数据
            getAllData() {
                axios
                    .get(this.iniselectURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {},
                    })
                    .then((res) => {
                        this.patchList = res.data.data.patchList;
                        this.accountIdList = res.data.data.accountList;

                        let arrs = res.data.data.statusList;

                        arrs.forEach((element) => {
                            let obj;
                            if (element == 0) {
                                obj = {
                                    label: "下单中",
                                    value: element,
                                };
                            } else if (element == 1) {
                                obj = {
                                    label: "下单成功",
                                    value: element,
                                };
                            } else if (element == 2) {
                                obj = {
                                    label: "下单失败",
                                    value: element,
                                };
                            } else if (element == 3) {
                                obj = {
                                    label: "跳过审核",
                                    value: element,
                                };
                            } else {
                                obj = {
                                    label: "未知状态",
                                    value: element,
                                };
                            }

                            this.statusList.push(obj);
                        });
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {});
            },

            // 查询
            searchOrderHistory() {
                this.getTableData();
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.getTableData();
            },
            //改变页数
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getTableData();
                this.scrollToTop();
            },
            // 获取数据
            getTableData() {
                axios
                    .get(this.getallOrderURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            ...this.formData,
                            multiplecate: this.multiplecate,
                        },
                    })
                    .then((response) => {
                        this.allpages = response.data.data.total;
                        this.tableData = response.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查看
            todaybuyclick(row) {
                var pa = row.patch;
                var sc = row.stickCode;

                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.getItem("sa"),
                        },
                        params: {
                            patch: pa,
                            stickCode: sc,
                            multiplecate: false,
                        },
                    })
                    .then((response) => {
                        if (response.data.code !== 200) {
                            this.$message.error("获取数据出错");
                            return;
                        }
                        if (response.data.data.length === 0) {
                            this.$message.error("无数据");
                            return;
                        }

                        this.data = response.data;
                        // 输出响应数据
                        this.selectItem(response.data.data.result[0], this.istoday);
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                        this.$message.error("获取数据出错");
                    });
            },

            // 打开详情页
            ...mapActions("shared",["updateSharedData", "updateCanbuyData"]),
            openPopup() {
                document.getElementById("cartover").style.display = "block";
            },
            closePopup() {
                if (this.$refs.detailsCardView) {
                    // 在调用之前检查 selectTab 方法是否存在
                    if (typeof this.$refs.detailsCardView.selectTab === "function") {
                        this.$refs.detailsCardView.selectTab(1);
                    } else {
                        console.error("子组件中未定义 selectTab 方法");
                    }
                } else {
                    console.error("子组件引用尚未可用");
                }
                document.getElementById("cartover").style.display = "none";
            },

            selectItem(item, can = true) {
                // 向vuex传递数据
                if (item == undefined || item == null) {
                    this.$message.error("获取数据出错");
                    return;
                }
                this.updateSharedData(item);
                this.updateCanbuyData(can);
                // 显示弹窗
                this.openPopup();
                // 获取出价账号
                axios
                    .get(this.orderByURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                    })
                    .then((res) => {
                        this.orderAccountList = res.data.data;
                    });
            },

            //获取下单账号
            getOrderAccount(item) {
                axios
                    .get(this.accountURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                    })
                    .then((res) => {})
                    .catch((error) => {})
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 时间函数
            updateTime() {
                const date = new Date();
                this.time = this.zeroPadding(date.getHours(), 2) + ":" + this.zeroPadding(date.getMinutes(), 2) + ":" + this.zeroPadding(date.getSeconds(), 2);
                this.date = this.zeroPadding(date.getFullYear(), 4) + "-" + this.zeroPadding(date.getMonth() + 1, 2) + "-" + this.zeroPadding(date.getDate(), 2);

                if (date.getMinutes() < 50 && date.getHours() <= 8) {
                    this.todaypatch = this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate() - 1, 2) + "_2";
                } else {
                    this.todaypatch = this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate(), 2) + "_2";
                }
            },
            // 时间格式化
            zeroPadding(num, digit) {
                let zero = "";
                for (let i = 0; i < digit; i++) {
                    zero += "0";
                }
                return (zero + num).slice(-digit);
            },
            // 处理 \"
            parseDefectUrls(defectUrl) {
                try {
                    const urls = JSON.parse(defectUrl);
                    return Object.values(urls);
                } catch (e) {
                    return [];
                }
            },
            // 处理 \"
            parseQualityDesc(desc) {
                try {
                    const quality = JSON.parse(desc);
                    let result = "";
                    for (let key in quality) {
                        result += `${key}: ${quality[key]} `;
                    }
                    return result.trim();
                } catch (e) {
                    return desc;
                }
            },
        },
        computed: {
            // 表格样式
            tableRowStyle() {
                return (row) => ({
                    background: row.rowIndex % 2 === 0 ? "rgba(14, 95, 255, 0.05)" : "rgba(14, 95, 255, 0.15)",
                    color: "black",
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    /* 分页样式 下面 */
    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .pagination ul {
        display: flex;
        list-style-type: none;
        padding: 0;
    }

    .pagination ul li {
        margin: 0 5px;
    }

    .pagination ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .pagination ul li.page-item a {
        text-decoration: none;
        padding: 5px 10px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: #f5f5f5;
    }

    .pagination ul li.page-item a:hover {
        background-color: #e9ecef;
    }

    .pagination ul li.page-item.active a {
        background-color: #007bff;
        color: white;
    }

    /* 悬停时显示完整信息 */
    // :deep(.el-table) {
    //     // 表格鼠标悬停样式
    //     --el-table-row-hover-bg-color: rgba(14, 95, 255, 0.5);

    //     .cell {
    //         // 溢出隐藏
    //         overflow: hidden;
    //         // 溢出用省略号显示
    //         text-overflow: ellipsis;
    //         // 规定段落中的文本不进行换行
    //         white-space: nowrap;

    //         br {
    //             display: none;
    //         }
    //     }

    //     .el-table__row:hover * {
    //         /* 悬停时取消 nowrap，允许换行显示完整内容 */
    //         white-space: normal;
    //         /* 悬停时取消溢出隐藏 */
    //         overflow: visible;

    //         br {
    //             display: inline;
    //         }
    //     }
    // }

    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;
        }
    }

    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
    }

    .card {
        background-color: transparent;
        border: 1px solid transparent;
    }

    .form-group {
        margin-bottom: 25px;
    }

    :deep(.el-form-item__content) {
        width: 160px;
    }

    :deep(.el-range-editor.el-input__wrapper) {
        margin: 0 32px 15px 0;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -56px;
        left: 130px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    :deep(.el-main) {
        --el-main-padding: 0px;
    }

    /* CSS 样式，用于弹窗外观 */
    .cartover {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* 半透明黑色背景 */
        z-index: 9999;
        /* 弹窗位于最上层 */
    }

    .scorllpop {
        overflow: auto;
        position: fixed;
        background-color: white;
        height: 100%;
        width: 70%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgb(12, 28, 248);
        /*	text-align: center;	*/
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        /* 确保弹窗在黑色背景之上 */
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
</style>
